import { gsap } from 'gsap';

export function initRequestSentSteps(parent) {
  if (!parent) return;

  const list = parent.querySelector('.request-sent-steps__list');
  const items = parent.querySelectorAll('.request-sent-steps__item');

  if (!list || !items.length) return;

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: list,
      start: 'top 75%',
      toggleActions: 'play none none none',
    },
    defaults: { ease: 'power2.out' },
  });

  const pointDuration = 0.58;
  const pointStartOffset = 0;
  const illustrationDelay = 0.06;
  const illustrationDuration = 0.62;
  const eyebrowDelay = 0.08;
  const eyebrowDuration = 0.36;
  const contentDelay = 0.08;
  const contentDuration = 0.62;
  const connectorDuration = 0.48;
  const itemTransitionOverlap = 0.24;

  let nextPointStart = 0;

  items.forEach((item, index) => {
    const point = item.querySelector('.request-sent-steps__point');
    const illustration = item.querySelector(
      '.request-sent-steps__illustration',
    );
    const eyebrow = item.querySelector('.request-sent-steps__eyebrow');
    const content = item.querySelector('.request-sent-steps__copy');
    const statusLines = item.querySelectorAll(
      '.request-sent-steps__status-line',
    );
    const hasConnector = item.classList.contains(
      'request-sent-steps__item--has-connector',
    );
    const isCentered = item.classList.contains(
      'request-sent-steps__item--centered',
    );
    const isCompleted = item.classList.contains(
      'request-sent-steps__item--completed',
    );
    const isActive = item.classList.contains(
      'request-sent-steps__item--active',
    );
    const pointStart = index === 0 ? pointStartOffset : nextPointStart;
    const illustrationStart = pointStart + illustrationDelay;
    const eyebrowStart = pointStart + eyebrowDelay;
    const contentStart = pointStart + contentDelay;
    let itemRevealEnd = pointStart + pointDuration;

    if (hasConnector || isCentered) {
      gsap.set(item, {
        '--_line-before-reveal': 0,
        '--_line-after-reveal': 0,
      });
    }

    if (point) {
      point.classList.remove('is-pulsing');
      point.classList.remove('is-glowing');
    }

    statusLines.forEach((line) => {
      line.classList.remove('is-animated');
    });

    if (point) {
      tl.to(
        point,
        {
          opacity: 1,
          scale: 1,
          y: 0,
          rotation: 0,
          filter: 'blur(0px)',
          duration: pointDuration,
          ease: 'power3.out',
        },
        pointStart,
      );

      if (isActive) {
        tl.call(
          () => {
            point.classList.add('is-pulsing');
          },
          null,
          pointStart + 0.08,
        );
      }

      if (isCompleted) {
        tl.call(
          () => {
            point.classList.add('is-glowing');
          },
          null,
          pointStart + 0.12,
        );
      }
    }

    if (isCentered) {
      tl.to(
        item,
        {
          '--_line-before-reveal': 1,
          duration: 0.22,
          ease: 'none',
        },
        pointStart + 0.02,
      );
    }

    if (illustration) {
      tl.to(
        illustration,
        {
          opacity: 1,
          y: 0,
          scale: 1,
          filter: 'blur(0px)',
          duration: illustrationDuration,
        },
        illustrationStart,
      );

      itemRevealEnd = Math.max(
        itemRevealEnd,
        illustrationStart + illustrationDuration,
      );
    }

    if (eyebrow) {
      tl.to(
        eyebrow,
        {
          opacity: 1,
          y: 0,
          filter: 'blur(0px)',
          duration: eyebrowDuration,
        },
        eyebrowStart,
      );

      itemRevealEnd = Math.max(itemRevealEnd, eyebrowStart + eyebrowDuration);
    }

    if (content) {
      tl.to(
        content,
        {
          opacity: 1,
          y: 0,
          filter: 'blur(0px)',
          clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
          duration: contentDuration,
        },
        contentStart,
      );

      itemRevealEnd = Math.max(itemRevealEnd, contentStart + contentDuration);
    }

    if (statusLines.length) {
      tl.to(
        statusLines,
        {
          opacity: 1,
          y: 0,
          filter: 'blur(0px)',
          duration: 0.34,
          stagger: 0.04,
        },
        pointStart + 0.3,
      );

      if (isActive) {
        tl.call(
          () => {
            statusLines.forEach((line) => {
              line.classList.add('is-animated');
            });
          },
          null,
          pointStart + 0.42,
        );
      }

      itemRevealEnd = Math.max(itemRevealEnd, pointStart + 0.42);
    }

    const transitionStart = hasConnector
      ? Math.max(pointStart, itemRevealEnd - itemTransitionOverlap)
      : itemRevealEnd;

    if (hasConnector) {
      tl.to(
        item,
        {
          '--_line-after-reveal': 1,
          duration: connectorDuration,
          ease: 'none',
        },
        transitionStart,
      );
    }

    nextPointStart = transitionStart;
  });
}

export function initAllRequestSentSteps(selector = '.js-request-sent-steps') {
  const blocks = document.querySelectorAll(selector);
  blocks.forEach((block) => initRequestSentSteps(block));
}
